import { ReadonlyDetail } from '@/common/components/employees/shared/ReadonlyDetail';
import { useEmployeeDetailContext } from '@/common/contexts/EmployeeDetailContext';

export const ConsultingFeeDetails = () => {
  const { employeeDetail } = useEmployeeDetailContext();

  return (
    <div className="mb-6">
      <div className="mb-4 font-semibold">Consulting Fee</div>
      <fieldset className="form-fieldset">
        <ReadonlyDetail label="Consulting Fee Currency">
          {employeeDetail.personalInformation.consultingFeeBankCurrencyId}
        </ReadonlyDetail>

        <ReadonlyDetail label="Bank Country">
          {employeeDetail.personalInformation.consultingFeeBankCountryCode}
        </ReadonlyDetail>

        <ReadonlyDetail label="Bank Name">{employeeDetail.personalInformation.consultingFeeBankName}</ReadonlyDetail>

        <ReadonlyDetail label="Branch Name">
          {employeeDetail.personalInformation.consultingFeeBranchName}
        </ReadonlyDetail>

        <ReadonlyDetail label="Account Number">
          {employeeDetail.personalInformation.consultingFeeAccountNumber}
        </ReadonlyDetail>

        <ReadonlyDetail label="Account Holder Name">
          {employeeDetail.personalInformation.consultingFeeAccountHolderName}
        </ReadonlyDetail>
      </fieldset>
    </div>
  );
};
